import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsCards = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Contracts',
      value: stats?.totalContracts,
      change: '+12%',
      changeType: 'positive',
      icon: 'FileText',
      color: 'bg-primary/10 text-primary',
    },
    {
      title: 'Active Contracts',
      value: stats?.activeContracts,
      change: '+8%',
      changeType: 'positive',
      icon: 'CheckCircle',
      color: 'bg-success/10 text-success',
    },
    {
      title: 'Expiring Soon',
      value: stats?.expiringSoon,
      change: '+3',
      changeType: 'warning',
      icon: 'AlertTriangle',
      color: 'bg-warning/10 text-warning',
    },
    {
      title: 'Total Value',
      value: stats?.totalValue,
      change: '+15%',
      changeType: 'positive',
      icon: 'DollarSign',
      color: 'bg-accent/10 text-accent',
    },
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      case 'warning':
        return 'text-warning';
      default:
        return 'text-muted-foreground';
    }
  };

  const getChangeIcon = (type) => {
    switch (type) {
      case 'positive':
        return 'TrendingUp';
      case 'negative':
        return 'TrendingDown';
      case 'warning':
        return 'AlertTriangle';
      default:
        return 'Minus';
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
      {statCards?.map((card, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg shadow-legal p-6 hover:shadow-legal-md transition-legal"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${card?.color}`}>
              <Icon name={card?.icon} size={24} />
            </div>
            <div className={`flex items-center space-x-1 text-sm ${getChangeColor(card?.changeType)}`}>
              <Icon name={getChangeIcon(card?.changeType)} size={14} />
              <span className="font-medium">{card?.change}</span>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-foreground mb-1">{card?.value}</h3>
            <p className="text-sm text-muted-foreground">{card?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStatsCards;